import React__default, { useMemo, useCallback, useState, useEffect } from 'react';
import { WranglerDataContext, useManagedWranglerSelectionsContext } from '@vp/wrangler-data-source';
import { ConfiguratorContext } from './configuratorContext.mjs';
import { wranglerAttributeToProductOptionModel } from './helpers/wranglerAttributesToProductOptionModel.mjs';
import { getUiLabels } from '../../providers/localization.mjs';
import { getPriceInfo } from './helpers/getPriceInfo.mjs';

const ConfiguratorContextProvider = ({ children, allOptionsRequired, onPriceUpdated, uiLabelOverrides, showFormErrors, onValidation }) => {
    const { data, updating: isLoading, context: wranglerContext } = React__default.useContext(WranglerDataContext);
    const { setSelections, setSelectedQuantity } = useManagedWranglerSelectionsContext();
    const uiLabels = useMemo(() => {
        return getUiLabels(wranglerContext.culture, uiLabelOverrides);
    }, [wranglerContext.culture, uiLabelOverrides]);
    const setSelectionsHandler = useCallback((selections) => {
        if (selections["Quantity"]) {
            // for now, we want to handle quantity separately
            const quantity = parseInt(selections["Quantity"], 10);
            setSelectedQuantity(quantity);
            delete selections["Quantity"];
        }
        setSelections(selections);
    }, [setSelections]);
    const setSelectedQuantityHandler = useCallback((selectedQuantity) => {
        setSelectedQuantity(selectedQuantity);
    }, [setSelectedQuantity]);
    const [priceInfo, setPriceInfo] = useState(undefined);
    const [productOptions, setProductOptions] = useState([]);
    useEffect(() => {
        if (data && wranglerContext) {
            setProductOptions(wranglerAttributeToProductOptionModel(data, uiLabels, allOptionsRequired));
            const wranglerPriceData = isLoading
                ? undefined
                : data.price;
            if (wranglerPriceData) {
                setPriceInfo(getPriceInfo(wranglerPriceData, wranglerContext, data));
            }
            else {
                setPriceInfo(undefined);
            }
        }
    }, [data, isLoading, wranglerContext, allOptionsRequired]);
    const context = useMemo(() => {
        if (data) {
            const mpvId = data.selections.mpvId;
            const productName = data.productName;
            const selections = data.selections.selectedAttributes;
            const document = data.selections.document;
            const selectedQuantity = data.selections.quantity;
            return {
                isLoading,
                priceInfo,
                mpvId,
                productName,
                productOptions,
                onPriceUpdated,
                selectedQuantity,
                setSelectedQuantity: setSelectedQuantityHandler,
                uiLabels,
                selections,
                setSelections: setSelectionsHandler,
                document,
                culture: wranglerContext.culture,
                merchant: wranglerContext.merchant,
                currency: data.price.currency,
                fractionDigits: data.price.fractionDigits,
                showFormErrors,
                onValidation,
            };
        }
        else {
            return undefined;
        }
    }, [priceInfo, isLoading, data, onPriceUpdated, setSelectedQuantityHandler, productOptions, uiLabels, showFormErrors, onValidation]);
    if (productOptions.length === 0)
        return null;
    return (React__default.createElement(ConfiguratorContext.Provider, { value: context }, children));
};

export { ConfiguratorContextProvider };
//# sourceMappingURL=configuratorContextProvider.mjs.map
